import React, {Component} from 'react';
import Navigation from '../Navigation';
import { Form, Container, Button, Alert } from 'react-bootstrap';
import { withRouter, Redirect } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from "@fortawesome/free-solid-svg-icons";

class Login extends Component<any, any> {
  constructor(props: any) {
    super(props);

    this.onSubmit = this.onSubmit.bind(this);
    this.handleFormChangeInput = this.handleFormChangeInput.bind(this);
    this.renderSelectOrg = this.renderSelectOrg.bind(this);
    this.handleSelectOrg = this.handleSelectOrg.bind(this);

    this.state = {
      username: '',
      password: '',
      error: false,
      isLoggingState: 'form'
    };
  }

  async onSubmit(e:any) {
    const { refreshCurrentUser, auth } = this.props;
    e.preventDefault();
    const { username, password } = this.state;
    // Clear previous auth state before new attempt
    localStorage.clear();
    this.setState({ error: false, isLoggingState: 'authenticating' });

    await auth.login({username, password})
      .then(() => {
        this.setState({isLoggingState: 'assigning_user' });
        setTimeout(async () => {
          await refreshCurrentUser();
          this.setState({isLoggingState: 'select_org' });
        }, 3000);
      }).catch((err:any) => {
        console.error("There was an error: ", err);
        return this.setState({ error: true, isLoggingState: 'form' });
      });
  }

  handleFormChangeInput(event: any) {
    let value = event.target.value;
    let name = event.target.name;
    this.setState((prevState:any) => ({
      ...prevState,
      [name as string]: value,
    }));
  }

  renderForm() {
    const { error, isLoggingState } = this.state;
    return (
      <div>
        <h2>Login to Datum</h2>
        <Form onSubmit={this.onSubmit}>
          {error &&
          <Alert variant="danger">A login error has occured. Either your username or password is incorrect or there is a server issue. Please try again.</Alert>
          }
          <Form.Group controlId="formGroupEmail">
            <Form.Label>Email address</Form.Label>
            <Form.Control type="email" name="username" onChange={this.handleFormChangeInput} placeholder="Enter Email" />
          </Form.Group>
          <Form.Group controlId="formGroupPassword">
            <Form.Label>Password</Form.Label>
            <Form.Control type="password" name="password" onChange={this.handleFormChangeInput} placeholder="Password" />
          </Form.Group>
          <Form.Group>
            <Button variant="primary" onClick={this.onSubmit}>
              {isLoggingState === "authenticating" &&
              <FontAwesomeIcon icon={faSpinner} size="lg" />
              }
              {isLoggingState !== "authenticating"  &&
                  'Login'
              }
            </Button>
          </Form.Group>
        </Form>
       {/*<a target="_blank" rel="noopener noreferrer" href={`https://syncarto-test-usw2.auth.us-west-2.amazoncognito.com/forgotPassword?client_id=38bicvma3kumdeaccprc51ku5i&response_type=code&scope=aws.cognito.signin.user.admin+email+openid+phone+profile&redirect_uri=https://app-test.syncarto.com/login`}>Forgot password?</a>*/}
        <a target="_blank" rel="noopener noreferrer" href={`${process.env.REACT_APP_COGNITO_DOMAIN}/forgotPassword?client_id=${process.env.REACT_APP_COGNITO_APP_CLIENT_ID}&response_type=code&scope=aws.cognito.signin.user.admin+email+openid+phone+profile&redirect_uri=${process.env.REACT_APP_URL}/login`}>Forgot password?</a>
        <div className="mt-4">
          <h5>Don't have an account?</h5>
          <Button 
            variant="primary"
            onClick={() => {
              this.props.history.push('/register');
            }}
          >
            Sign up for free
          </Button>
        </div>
      </div>

    )
  }

  renderLoggingUser() {
    return (
      <div>
        <h2 className="text-center">Logging you in ...</h2>
      </div>
    )
  }

  handleSelectOrg(evt: any, userOrg: any) {
    evt.preventDefault();
    console.log('handleSelectOrg', userOrg);
    this.setState({isLoggingState: 'assigning_user' }, async () => {
      await this.props.refreshAllCredentials(userOrg.orgId);
      this.setState({isLoggingState: 'redirecting' });
    });
  }

  renderSelectOrg() {
    if (!this.props.userOrgs.length) {
      return (<div>Loading...</div>);
    }

    return (
      <div>
        <div><h3>Please select an org:</h3></div>
        <ul>
          {this.props.userOrgs.map((userOrg: any, i: number) => {
            return (
              <li key={i}>
                { // eslint-disable-next-line
                }<a href="" onClick={(e: any) => this.handleSelectOrg(e, userOrg)}>{userOrg.orgName}</a>
              </li>
            );
          })}
        </ul>
      </div>
    );
  }

  render() {
    const { isLoggingState } = this.state;
    let containerElement;
    switch(isLoggingState) {
      case 'form':
      case 'authenticating':
        containerElement = this.renderForm();
        break;
      case 'assigning_user':
        containerElement = this.renderLoggingUser();
        break;
      case 'select_org':
        containerElement = this.renderSelectOrg();
        break;
      case 'redirecting':
        console.log("Now we're logging in");
        return <Redirect to={process.env.REACT_APP_FIELD_MGR_ROOT_URL} push={true} />;
      default:
        containerElement = <div>Unknown login state</div>
    }

    return (
      <div>
        <Navigation showDashboardOptions={false}/>
        <Container className="dashboard_container">
          {containerElement}
        </Container>
      </div>
    );
  }
}

export default withRouter(Login);
